const settings = {
  HEADER_HEIGHT: 130,
  NAVBAR_HEIGHT: 70,
  SUBBAR_HEIGHT: 60
}

export default settings
